<template>
  <div class="events">

    <v-toolbar color="transparent" flat>
      <v-toolbar-title>History changes</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-banner>
      The change history tool shows each change within a timeline.
    </v-banner>

    <v-data-table
    :headers="headers"
    :items="events"
    :loading="loading"
    :itemsPerPage="25"
    :server-items-length="totalEvents"
    :footer-props="{ itemsPerPageOptions: [25] }"
    :options.sync="options"
    disable-sort
    show-expand
    class="elevation-1"
    >

    <template v-slot:item.change="{ item }">
      <RemoteStatus :status="item.old_status" />
      <v-icon class="mx-2">mdi-chevron-right</v-icon>
      <RemoteStatus :status="item.new_status" />
    </template>

    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | longDate }}
    </template>

    <template v-slot:item.issuer="{ item }">
      <v-chip label outlined small>{{ item.issuer }}</v-chip>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <a :key="url" v-for="url in item.url_array" :href="url">{{ url }}</a>
      </td>
    </template>

    </v-data-table>

  </div>
</template>

<script>

import { fetchEvents } from '@/api'
import RemoteStatus from '@/components/RemoteStatus.vue'

export default {
  name: 'events',
  props: ['projectId'],
  components: { RemoteStatus },
  data () {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'Item', value: 'item_id' },
        { text: 'Date', value: 'created_at' },
        { text: 'Change', value: 'change' },
        { text: 'Issuer', value: 'issuer' }
      ],
      loading: false,
      options: {},
      events: [],
      totalEvents: 0
    }
  },

  watch: {
    options: {
      handler: 'getDataFromApi',
      deep: true,
    }
  },

  methods: {

    getDataFromApi () {
      this.loading = true
      const { page } = this.options
      fetchEvents(this.projectId, { page }).then(data => {
        this.events = data.entries
        this.totalEvents = data.total
        this.loading = false
      })
    }

  }

}

</script>
